var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoutButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_560_1913",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_560_1913)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 12C11.7871 12 11.609 11.9282 11.4655 11.7845C11.3218 11.6407 11.25 11.4625 11.25 11.25V3.173C11.25 2.9605 11.3219 2.78242 11.4658 2.63875C11.6096 2.49492 11.7878 2.423 12.0003 2.423C12.2129 2.423 12.391 2.49492 12.5345 2.63875C12.6782 2.78242 12.75 2.9605 12.75 3.173V11.25C12.75 11.4625 12.6781 11.6407 12.5343 11.7845C12.3904 11.9282 12.2122 12 11.9998 12ZM12.0005 20.5C10.8207 20.5 9.71542 20.2769 8.68475 19.8308C7.65392 19.3846 6.75517 18.7782 5.9885 18.0115C5.22183 17.2448 4.61542 16.3463 4.16925 15.3158C3.72308 14.2853 3.5 13.18 3.5 12C3.5 11.0025 3.6715 10.0374 4.0145 9.10476C4.3575 8.17209 4.84883 7.325 5.4885 6.5635C5.62483 6.38784 5.79833 6.30417 6.009 6.31251C6.21967 6.32084 6.40733 6.40734 6.572 6.57201C6.71117 6.71117 6.77242 6.87884 6.75575 7.07501C6.73908 7.27117 6.66667 7.45709 6.5385 7.63275C6.03717 8.24559 5.65542 8.92792 5.39325 9.67976C5.13108 10.4318 5 11.2052 5 12C5 13.95 5.67917 15.6042 7.0375 16.9625C8.39583 18.3208 10.05 19 12 19C13.95 19 15.6042 18.3208 16.9625 16.9625C18.3208 15.6042 19 13.95 19 12C19 11.1978 18.8715 10.4175 18.6145 9.659C18.3573 8.9005 17.9679 8.21484 17.4462 7.60201C17.3179 7.43651 17.2454 7.25659 17.2288 7.06225C17.2121 6.86775 17.273 6.7015 17.4115 6.5635C17.5667 6.40834 17.7491 6.32817 17.9587 6.323C18.1683 6.318 18.3422 6.39817 18.4808 6.5635C19.1307 7.325 19.6298 8.16934 19.9778 9.0965C20.3259 10.0237 20.5 10.9915 20.5 12C20.5 13.18 20.2769 14.2853 19.8307 15.3158C19.3846 16.3463 18.7782 17.2448 18.0115 18.0115C17.2448 18.7782 16.3463 19.3846 15.316 19.8308C14.2855 20.2769 13.1803 20.5 12.0005 20.5Z",
    fill: "#808282"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutButton);
export default __webpack_public_path__ + "static/media/logout-button.cfd08c5ee12abcd69fe309a2bb9cdd97.svg";
export { ForwardRef as ReactComponent };